module.exports = __webpack_public_path__ + "static/media/app-store.a2d08750.png";